import React from 'react';
import ReactDOM from 'react-dom/client'; // Use react-dom/client for React 18+
import './styles/index.css';
import App from './App';
import "@amzn/meridian-tokens/base/font/amazon-ember.css"
import * as serviceWorker from './serviceWorker';
import Modal from "react-modal";
import { isLocalhost } from "./utils/environmentUtils";

const render = () => {
  const root = ReactDOM.createRoot(document.getElementById('root'));
  root.render(<App />);

  // required by Modal to take the focus so screen reader does not read the other elements
  Modal.setAppElement('#root');
};

if (isLocalhost()) {
  // Fake backend + Zoom SDK for local dev (src/localtest/mocks). Leave the MSW service worker
  // registered — unregister() below would remove it.
  import("./localtest/mocks/browser").then(({ startMocks }) => startMocks()).then(render);
} else {
  render();
  // If you want your app to work offline and load faster, you can change
  // unregister() to register() below. Note this comes with some pitfalls.
  // Learn more about service workers: https://bit.ly/CRA-PWA
  serviceWorker.unregister();
}